module.exports = __webpack_public_path__ + "2a03dbca94a2c4942187d4e4db3c1d44.svg";